import React from "react";
import FatoresDeRiscoDNList from "./_/components/FatoresDeRisco/FatoresDeRiscoDNList";

const GestorDN = (props) => {
  return <React.Fragment></React.Fragment>;
};

export default GestorDN;
